import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './Router'
import './index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { setupCSSVariables } from './assets/icons';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://ba3b2bb03db5f5ffa01293991d637ea9@o4509882054410240.ingest.us.sentry.io/4509882055393280",
  sendDefaultPii: true
});

// React Query 클라이언트 생성
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      gcTime: Infinity,
    },
  },
})


// CSS 변수 설정
setupCSSVariables();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>
)
